module.exports = __webpack_public_path__ + "img/end-user-background.6a9bea46.png";